angular.module("admin").factory("FlexService", ["$rootScope", "$http", "ENV", function ($rootScope, $http, ENV) {

	/**
	 * API
	 */
	return {
		hasData:hasData
	};


	function hasData(providerId){
		return $http.get(ENV.FLEX_BASE_URL + "admin/has-data/" + providerId, {
			transformRequest: angular.identity
		});
	}


}]);